import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

const colours = [
    '#FFB6C1',
    '#FFA07A',
    '#FF7F50',
    '#FF6347',
    '#FF4500',
    '#FFD700',
    '#FFA500',
    '#FF8C00',
    '#FF69B4',
    '#FF1493',
    '#FFC0CB',
    '#FFB6C1',
    '#FF69B4',
    '#FF1493',
    '#FF00FF',
    '#EE82EE',
    '#DA70D6',
    '#BA55D3',
    '#9932CC',
    '#8A2BE2',
    '#9400D3',
    '#800080',
    '#4B0082',
    '#6A5ACD',
    '#483D8B',
    '#7B68EE',
    '#4169E1',
    '#0000FF',
    '#0000CD',
    '#00008B',
];

type AvatarProps = {
    firstName: string;
    lastName: string;
    colour?: string;
    className?: string;
};
export const Avatar: FunctionComponent<AvatarProps> = ({
    firstName,
    lastName,
    colour,
    className,
}) => {
    const colourIndex = (firstName.charCodeAt(0) + lastName.charCodeAt(0)) % colours.length;
    const selectedColour = colour || colours[colourIndex];

    return (
        <div
            style={{ backgroundColor: selectedColour || undefined }}
            className={classNames(styles.avatar, className)}
        >
            {firstName[0]}
            {lastName[0]}
        </div>
    );
};
